window.addEventListener('load', () => {
  const $elContent = document.querySelector('.swiper#ProductBenefitsContent');
  const categories = JSON.parse($elContent.getAttribute('data-categories'));
  const $elImages = document.querySelector('.swiper#ProductBenefitsImages');

  const swiperImages = new Swiper($elImages, {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      990: {
        slidesPerView: 3,
        centeredSlides: true,
      },
    },
  });

  const swiperContent = new Swiper($elContent, {
    // init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => {
        return `<span class="product-benefits__button ${className}">${categories[index]}</span>`;
      },
      renderCustom: (swiper, current, total) => `${current} of ${total}`,
    },
  });

  swiperImages.controller.control = swiperContent;
  swiperContent.controller.control = swiperImages;
  if (swiperImages.slides.length > 2) {
    swiperImages.slideTo(1);
  }
});
